import { FUNNELS_API } from 'modules/funnels/api/funnels-api'
import { ListingFunnelInterface } from 'modules/funnels/funnel/types/funnel-interface'
import { FunnelId } from 'modules/funnels/types/funnel-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export function useFunnels(funnelId: FunnelId, shouldFetch: boolean) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ListingFunnelInterface[]>({
    method: RequestMethodsEnum.get,
  })

  const { data: funnelsList } = useSWR(() => {
    if (user && shouldFetch) {
      return `${FUNNELS_API}/${funnelId}/list`
    }
    return null
  }, fetcher)

  return { funnelsList }
}
